import { useLayoutEffect, type FC } from "react";
import clsx from "clsx";
import PullToRefreshPage from "./PullToRefreshPage";
import { useSetHeaderColor } from "~/hook/useSetHeaderColor";

export interface PageProps {
    onRefresh?: () => Promise<void>;
    bgThemeKey?: string;
}

export const Page: FC<React.PropsWithChildren<PageProps>> = ({
    bgThemeKey = "bg_0",
    onRefresh,
    children,
}) => {
    useSetHeaderColor({ themeKey: bgThemeKey });

    useLayoutEffect(() => {
        const layoutContainer =
            document.querySelector<HTMLDivElement>("#uxuy-dex-app");
        if (layoutContainer) {
            for (const classItem of layoutContainer.classList.values()) {
                if (classItem.startsWith("bg-")) {
                    layoutContainer.classList.remove(classItem);
                }
            }
            layoutContainer.classList.add(`bg-${bgThemeKey}`);
        }
    }, []);

    const pageContent = (
        <div className={clsx(`bg-${bgThemeKey}`, "min-h-screen")}>
            {children}
        </div>
    );

    const enablePull2Refresh = typeof onRefresh === "function";

    if (enablePull2Refresh) {
        return (
            <PullToRefreshPage onRefresh={onRefresh}>
                {pageContent}
            </PullToRefreshPage>
        );
    }

    return pageContent;
};
